import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import loadJS from "../utils/load-js";

@Component
class GMap extends Vue {
    @Prop({ type: Number, default: 0 }) public lat: number;
    @Prop({ type: Number, default: 0 }) public long: number;
    @Prop({ type: Number, default: 50 }) public scale: number;
    @Prop({ type: Number, default: 1 }) public zoom: number;
    @Prop({ type: String, default: null }) public apiKey: string | null;

    public isLoaded: boolean = false;
    public map: google.maps.Map;
    public marker: google.maps.Marker;
    public icon: google.maps.Icon;

    @Watch("lat")
    public onLatChanged(newVal: number) {
        if (this.isLoaded && newVal !== 0 && this.long !== 0) { this.moveMap(); }
    }

    @Watch("long")
    public onLongChanged(newVal: number) {
        if (this.isLoaded && newVal !== 0 && this.lat !== 0) { this.moveMap(); }
    }

    public async mounted() {
        if (!this.apiKey) { return; }
        await loadJS(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey!}`);
        this.initMap();
    }

    public moveMap() {
        const coords = new google.maps.LatLng(this.lat, this.long);

        google.maps.event.trigger(this.map, "resize");
        // this.map.panTo(coords);
        this.map.setCenter(coords);
        this.marker.setPosition(coords);
    }

    public initMap() {
        this.map = new google.maps.Map(this.$el, {
            gestureHandling: "cooperative",
            clickableIcons: false,
            zoom: this.zoom,
            center: { lat: 0, lng: 0 },
            styles: [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            color: "#f5f5f5",
                        },
                    ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#bdbdbd",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#757575",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#dadada",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#616161",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#e5e5e5",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeeeee",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#c9c9c9",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#9e9e9e",
                        },
                    ],
                },
            ],
        });

        this.icon = {
            url: `${ window.$$currentPath }/.resources/main/webresources/images/marker-${ window.$$rootKey }.png`,
            scaledSize: new google.maps.Size(32, 32),
        };

        // Create markers.
        this.marker = new google.maps.Marker({
            position: { lat: 0, lng: 0 },
            icon: this.icon,
            map: this.map,
            optimized: false,
        });

        this.isLoaded = true;
        if (this.lat !== 0 && this.long !== 0) { this.moveMap(); }
    }
}

export { GMap };



// WEBPACK FOOTER //
// ./src/scripts/components/google-map.ts